import Quote from '@commons/components/Quote';
import RichText from '@commons/components/RichText';
import Text from '@commons/components/Text';

import type { TestimonialNodeProps } from '.';
import styles from './Default.module.scss';

/**
 * Testimonial node component for the Default display type.
 */

const TestimonialNodeDefault = (props: TestimonialNodeProps) => {
  const { quote, name, position } = props;

  return (
    <Quote
      withIcon
      border={{ xs: 'top', md: 'left' }}
      paddingTop={{ xs: 'xl', md: 'none' }}
      paddingLeft={{ xs: 'none', md: 'xl' }}
      className={styles.testimonial}
    >
      <RichText value={quote} marginBottom="sm" />
      {name && (
        <Text level="body-xs" weight="semibold" transform="uppercase" marginBottom={4}>
          {name}
        </Text>
      )}
      {position && (
        <Text
          level="body-xs"
          weight="semibold"
          transform="uppercase"
          marginBottom="none"
          className={styles.position}
        >
          {position}
        </Text>
      )}
    </Quote>
  );
};

export default TestimonialNodeDefault;
